module.exports = __webpack_public_path__ + "static/media/background.9f2aa3e6.png";